var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 647,
    height: 814,
    viewBox: "0 0 647 814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "49.993%",
    x2: "49.993%",
    y1: "125.267%",
    y2: "-20.967%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C1B8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "13%",
    stopColor: "#CAC3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69%",
    stopColor: "#F0EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "98%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "51.129%",
    x2: "49.625%",
    y1: "238.428%",
    y2: "-18.958%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C1B8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "13%",
    stopColor: "#CAC3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    stopColor: "#F0EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M433.293 154.704C427.1 96.922 402.8 61.557 357.695 33.756 313.21 6.296 261.062-1.547 210.463 1.315c-1.383.083-2.756.29-4.102.619l-1.455.356a48.862 48.862 0 0 1-3.328.696c-35.6 6.42-67.61 31.39-89.482 64.032C89.9 100.17 77.408 140.672 71.418 181.762c-4.643 31.652-5.402 65.1 5.186 94.864 6.191 17.42 16.02 32.844 23.217 49.784a174.458 174.458 0 0 1 13.529 62.794c.542 19.385-2.167 39.032-9.21 56.715-4.644 11.664-11.067 22.292-17.49 32.843-25.479 41.77-51.498 83.819-68.525 130.849-14.194 39.217-21.67 82.751-16.422 124.382a41.264 41.264 0 0 0 26.7 33.246c172.649 61.881 486.942 31.745 597.66 18.394a22.35 22.35 0 0 0 17.682-12.876 22.33 22.33 0 0 0-1.785-21.793c-9.875-14.527-19.998-33.261-24.348-53.543-5.882-27.352-5.417-61.077-4.396-92.59 1.75-53.62 4.644-107.365 3.189-161.047-1.455-53.683-7.74-108.556-21.81-146.613-18.11-49.01-45.414-61.773-70.938-67.39-25.524-5.615-52.302-7.394-74.591-41.553-7.4-11.355-14.24-26.531-18.435-46.597",
    opacity: 0.65,
    transform: "translate(.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M26.661 7.77C13.207 7.941 2.536 20.53.628 33.536c-1.909 13.008 2.958 26.046 8.81 37.888 6.823 13.8 15.585 27.336 28.753 35.635 13.168 8.298 31.68 10.086 44.148.808 11.562-8.578 15.299-24.539 12.723-38.494-2.577-13.955-10.48-26.419-18.623-38.121-7.586-10.956-16.11-22.13-28.435-27.6-12.325-5.47-29.437-2.828-35.64 8.936",
    opacity: 0.75,
    transform: "translate(480.5 60)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.5 228)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DCCEFD",
    d: "M14.675 97.41h159.636c8.017 0 14.505 5.656 14.505 12.611v148.074c0 6.97-6.488 12.611-14.505 12.611H14.675c-8.017 0-14.505-5.64-14.505-12.61V110.02c0-6.955 6.488-12.611 14.505-12.611z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.242,
    height: 53.814,
    x: 21.889,
    y: 196.816,
    fill: "#F4F0FD",
    rx: 5.121
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.242,
    height: 75.992,
    x: 47.007,
    y: 174.654,
    fill: "#F4F0FD",
    rx: 5.121
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.242,
    height: 123.284,
    x: 73.592,
    y: 127.346,
    fill: "#F4F0FD",
    rx: 5.121
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.242,
    height: 95.203,
    x: 98.71,
    y: 155.428,
    fill: "#F4F0FD",
    rx: 5.121
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.242,
    height: 68.605,
    x: 123.828,
    y: 182.041,
    fill: "#F4F0FD",
    rx: 5.121
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.242,
    height: 111.461,
    x: 148.93,
    y: 139.169,
    fill: "#F4F0FD",
    rx: 5.121
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B6FC",
    d: "M6.874.244H80.73a6.412 6.412 0 0 1 6.72 6.028v70.722a6.396 6.396 0 0 1-6.72 6.012H6.874A6.381 6.381 0 0 1 .17 76.994V6.272A6.396 6.396 0 0 1 6.874.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C7FD",
    d: "M107.33.244h73.855a6.396 6.396 0 0 1 6.704 6.028v70.722a6.381 6.381 0 0 1-6.704 6.012H107.33a6.396 6.396 0 0 1-6.72-6.012V6.272a6.412 6.412 0 0 1 6.72-6.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F0FD",
    d: "M35.638 53.085c-2.997.757-5.886-.247-4.96 3.09a6.179 6.179 0 0 0 7.122 4.637 5.732 5.732 0 0 0 3.754-7.34c-.927-3.478-2.935-1.206-5.916-.387zM35.097 51.54c6.024-1.391 4.464-3.092 5.129-6.584.664-3.493-4.697-13.122-10.876-11.715-6.179 1.406-4.927 12.364-2.533 14.852 2.642 2.844 2.24 4.884 8.28 3.446zM49.525 44.724c-3.09-.773-4.99-2.998-5.916.278a5.736 5.736 0 0 0 3.753 7.341 6.179 6.179 0 0 0 7.122-4.636c.926-3.215-1.962-2.226-4.959-2.983zM55.828 24.462c-6.18-1.406-11.509 8.531-10.814 11.777.695 3.246-.896 5.193 5.144 6.584 6.04 1.39 5.639-.665 8.28-3.508 2.317-2.566 3.538-13.43-2.61-14.853z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F0FD",
    strokeLinecap: "round",
    strokeWidth: 9,
    d: "M27.018 67.566C12.796 58.201 8.765 39.125 17.98 24.802M44.057 10.6c13.265-.02 25.074 8.403 29.382 20.955A31.042 31.042 0 0 1 63.12 66.148a31.007 31.007 0 0 1-36.056 1.418M144.512 10.6c17.13.008 31.01 13.906 31.003 31.043-.005 17.137-13.894 31.026-31.023 31.023-17.13-.002-31.014-13.896-31.014-31.033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F0FD",
    d: "M154.646 32.823a1.544 1.544 0 0 0-1.545.449 1.376 1.376 0 0 0-.17 1.545 12.09 12.09 0 0 1 1.468 5.78c-.136 7.11-5.994 12.77-13.1 12.658a13.665 13.665 0 0 1-3.785-.541 1.544 1.544 0 0 0-1.544.448 1.376 1.376 0 0 0-.17 1.546 16.033 16.033 0 0 0 14.227 8.392c7.728.132 14.364-5.47 15.534-13.113 1.17-7.644-3.487-14.976-10.9-17.164h-.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F0FD",
    d: "M133.513 35.62a1.452 1.452 0 1 0 0 2.89h4.635l-5.963 6.291a1.268 1.268 0 0 0-.232 1.546c.313.551.913.875 1.545.834h8.218a1.452 1.452 0 1 0 0-2.89h-4.696l5.978-6.29a1.314 1.314 0 0 0 .232-1.546 1.699 1.699 0 0 0-1.545-.834h-8.172zM136.48 28.929a1.546 1.546 0 0 0-1.653-1.453h-1.638l2.95-3.462a1.283 1.283 0 0 0 .155-1.545 1.668 1.668 0 0 0-1.467-.804h-4.928a1.452 1.452 0 1 0 0 2.89h1.637l-2.95 3.462a1.283 1.283 0 0 0-.155 1.545c.324.537.92.848 1.545.804h4.928a1.545 1.545 0 0 0 1.575-1.437z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M371.204 325c2.876-6.231 17.385-50.691 20.324-73.738 8.927-14.143 58.659-93.364 58.659-93.364s4.846-17.534-4.08-11.715c-8.928 5.82-69.51 67.721-77.202 80.795-7.691 13.073-33.66 82.963-34.394 86.582-.735 3.62 36.693 11.44 36.693 11.44z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.993,
    cy: 519.754,
    fill: "#F7BDAD",
    rx: 12.586,
    ry: 9.054,
    transform: "rotate(-14.72 374.993 519.754)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M439.558 399c21.028 11.53 48.143 54.83 50.473 58.891 6.383 11.066 5.016 25.68 1.553 27.695-13.977 8.043-104.968 39.457-109.845 38.387-4.876-1.069-.605-15.14 1.693-14.536 2.298.604 37.614-28.95 78.63-42.325-6.011-2.355-37.273-33.862-39.867-37.752-2.593-3.89 17.363-30.36 17.363-30.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4738A7",
    d: "M332.975 517c9.849.216 94.467 45.323 128.525 69.868C456.056 617.742 414.972 789 414.972 789l-19.355-.417s1.442-170.841-.155-169.59c-39.425.972-92.528-20.516-136.962-20.594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE8E68",
    d: "M134.198 778l15.302 6.899L144.384 796l-17.884-3.324zM396.067 799.271l.265-12.037 16.443.361-.265 12.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5648B6",
    d: "M378.5 512.29L149.978 786l-15.478-7.073L277.034 466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74C",
    d: "M394.15 365.829c12.914-13.32 61.04 24.312 59.304 31.795-1.736 7.482-29.622 36.92-38.44 34.199-7.02-2.12-34.252-52.17-20.865-65.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD45C",
    d: "M395.712 340.302c65.354 29.395-12.448 188.276-26.453 191.487-14.004 3.211-100.302-31.07-102.699-46.22-2.396-15.15 67.082-173.202 129.152-145.267z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC74E",
    d: "M342.753 376.783c-18.24-3.79-14.504-65.598-7.393-68.26 7.112-2.662 47.2 5.261 50.013 14.297 2.157 7.266-23.646 57.893-42.62 53.963z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D163D",
    d: "M126.923 791l-30.363 9.197-.06 5.386 49.835.417.165-14.838zM395.803 799l-.303 14.072 42.879.928.121-5.105-25.836-9.536z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB5A9",
    d: "M428.5 311.592L402.663 300l-16.712 36.108c-4.151 8.958 21.624 20.718 25.837 11.592l16.712-36.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BDAD",
    d: "M455.392 301.86c4.222-21.603-3.994-41.507-18.346-44.5-12.332-2.493-25.12 8.183-31.21 24.94-4.453-.62-8.682 2.186-9.959 6.609-1.277 4.423.778 9.14 4.842 11.112.494.217 1.001.399 1.518.546-.577 17.706 7.2 32.545 19.425 35.07 14.351 2.93 29.539-12.189 33.73-33.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D163D",
    d: "M408.468 291.68c3.438 1.565 6.185-2.897 8.1-7.078 2.574-5.622 10.235-8.253 13.955-7.72 6.75 1.002 9.984 1.973 14.49 1.66 4.505-.314 10.14-1.3 10.14-1.3a56.936 56.936 0 0 1 1.57 8.08c3.72.595 22.966 4.353 28.633-8.049 3.72-8.142-2.653-12.323-4.615-16.3-2.073-4.229 3.14-11.792-5.887-15.879-8.069-3.664-15.886 2.975-22.526 3.883-8.038 1.097-18.838-7.626-30.658-3.006-5.746 2.24-11.193 11.713-15.274 14.234-5.573 3.398-11.978 2.208-15.4 9.693-2.511 5.496-2.072 16.896 2.936 20.81 2.48-5.433 6.844-9.724 10.863-7.829 4.348 1.942-1.366 6.514 3.673 8.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.976,
    cy: 155.928,
    fill: "#FBB5A9",
    rx: 19.615,
    ry: 13.264,
    transform: "rotate(-60.77 441.976 155.928)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B6FC",
    d: "M596.49 224.683v73.619c.188 3.5-2.537 6.491-6.1 6.698h-71.765c-3.566-.207-6.295-3.196-6.117-6.698v-73.62c-.178-3.499 2.554-6.483 6.117-6.682h71.765c3.56.199 6.288 3.186 6.1 6.683z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C7FD",
    d: "M596.5 330.308v146.384c0 7.342-2.73 13.308-6.102 13.308h-71.78c-3.373 0-6.118-5.966-6.118-13.308V330.308c0-7.342 2.745-13.308 6.118-13.308h71.78c3.373 0 6.102 5.966 6.102 13.308z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F0FD",
    strokeLinecap: "round",
    strokeWidth: 9,
    d: "M582.5 262.512c-.006 13.94-9.464 26.103-22.975 29.542-13.51 3.44-27.633-2.72-34.305-14.96-6.671-12.24-4.194-27.447 6.02-36.937 10.212-9.49 25.56-10.847 37.28-3.296M526.5 383.89c10.795 12.648 30.018 14.804 43.531 4.882 13.514-9.922 16.487-28.376 6.733-41.79-9.753-13.413-28.747-16.991-43.012-8.103"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F0FD",
    fillRule: "nonzero",
    d: "M550.46 380.376c-2.058.001-4.07-.629-5.784-1.81h1.22c7.36-.025 13.314-6.213 13.314-13.837.023-.421.023-.843 0-1.264a11.257 11.257 0 0 1 .442 11.083c-1.81 3.502-5.312 5.71-9.147 5.766l-.045.062zm6.024-26.895C547.267 347.13 551.44 341 551.44 341c-8.962 5.351-10.95 13.51-8.75 23.822-3.24-2.714-3.706-5.928-3.6-10.156-4.112 4.556-4.85 9.36-4.519 14.603.4 8.285 7.026 14.777 15.035 14.73 8.01-.045 14.565-6.612 14.877-14.902.27-6.864-2.47-11.935-7.983-15.616h-.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F0FD",
    d: "M585.5 450.008c0 15.46-12.536 27.992-28 27.992s-28-12.533-28-27.992a27.724 27.724 0 0 1 1.541-9.244c4.731 1.54 27.137 9.922 27.137 9.922l-8.29-27.654a51.729 51.729 0 0 1 7.581-1.032 27.988 27.988 0 0 1 19.83 8.189 27.973 27.973 0 0 1 8.201 19.819z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B59FFC",
    d: "M521.5 431.69l28 10.31-8.845-28s-13.268 1.48-19.155 17.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F0FD",
    d: "M568.709 274.978l-12.49-12.912L541.66 247h-1.135l-.233.618a11.016 11.016 0 0 0-.772 4.776 6.924 6.924 0 0 0 1.835 4.309l11.384 11.781 1.456-1.506 10.525 12.173a2.734 2.734 0 0 0 3.96 0 2.97 2.97 0 0 0 0-4.098l.029-.075zM548.177 265l-9.778 9.762a3.068 3.068 0 0 0 4.339 4.34l9.762-9.763-4.323-4.339zM570.9 252.366l-6.19 5.158-1.601-1.35 6.172-5.142-1.619-1.35-6.172 5.144-1.618-1.334 6.19-5.143-1.62-1.349-8.057 6.714c-.98.822-1.567 1.912-1.654 3.069a2.554 2.554 0 0 1-.231.86l5.23 4.357c.33-.107.677-.172 1.03-.193 1.39-.065 2.702-.556 3.683-1.378l8.057-6.715-1.6-1.348z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero3);
export default __webpack_public_path__ + "static/media/hero-3.d964a429f7eb1e194d07cc04042923f3.svg";
export { ForwardRef as ReactComponent };